export const TAU = Math.PI * 2;
export const LINE_WIDTH_PERCENT = 0.20;
export const BASE_ROTATION = -Math.PI / 2; // angle 0 will point up
export const SHADOW_SIZE_PERCENT = 0.09;
export const TOUCHABLE_AREA_PERCENT_INNER =
  LINE_WIDTH_PERCENT + SHADOW_SIZE_PERCENT / 2;
export const MAX_WIDTH_SCREEN = 1440;
export const MIN_PERCENT_DISPLAYED = 8;
export const MIN_PERCENT_FOR_ZERO_DISPLAYED = 0.5;
export const MIN_PERCENT_SELECTED_DISPLAYED = 8;
export const SEPARATOR_WIDTH = 1;
